// Cosine similarity between two equal-length vectors.
//
// Both inputs are expected to be L2-normalized; in that case this reduces to
// a plain dot product. We clamp to [-1, 1] to guard against float drift that
// can produce scores like 1.0000001 when summing many fp16-rounded products.
export function cosineSimilarity(
  a: ReadonlyArray<number> | Float32Array,
  b: ReadonlyArray<number> | Float32Array,
): number {
  if (a.length !== b.length) {
    throw new Error(
      `cosineSimilarity: length mismatch (${a.length} vs ${b.length})`,
    );
  }

  let dot = 0;

  for (let i = 0; i < a.length; i += 1) {
    dot += a[i] * b[i];
  }

  if (dot > 1) return 1;
  if (dot < -1) return -1;

  return dot;
}
